import Box from '@mui/material/Box';
import { styled } from '@mui/system';

export const StyledMiddleDot = styled(Box)(({ theme }) => {
    return {
        backgroundColor: theme.palette['text']?.primary,
        borderRadius: '99rem',
        padding: '2px',
    };
});
